<template>
  <div class="newsCard" @click="$router.push(`/academic/trends/detail?id=${data.Id}`)">
    <a class="title">{{data.Title}}</a>
    <p class="preview" v-html="data.Brief"></p>
    <div>
      <p class="date">{{this.$utils.timeResult(data.AdminSetTime).day}}</p>
      <p class="month">{{this.$utils.timeResult(data.AdminSetTime).year}}.{{this.$utils.timeResult(data.AdminSetTime).month}}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "newsCard",
  props: {
    data: {
      type: Object
    }
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.newsCard {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 25px;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid transparent;
  height: 400px;
  border-radius: 3px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.35);
  transition: .15s;
  cursor: pointer;
  &:hover {
    border: 1px solid #d7d7d7;
    border-radius: 3px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  }
  div {
    text-align: right;
  }
}
.title {
  color: #333333;
  font-weight: 400;
  font-size: 20px;
  line-height: 32px;
  margin-bottom: 10px;
  flex-wrap: wrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.preview {
  flex: 1;
  font-size: 16px;
  color: #c5c5c7;
  text-align: justify;
  text-justify: inter-word;
  @include hideTextOverflow;
  line-height: 32px;
  white-space: normal;
}
.date {
  font-weight: 700;
  font-style: normal;
  font-size: 28px;
  color: #7f7f7f;
  line-height: 24px;
}
.month {
  font-size: 16px;
  color: #7f7f7f;
  line-height: 24px;
}
</style>


